// @flow
import { useCallback } from 'react';
import classnames from 'classnames';

import FilterSection from '../catalogFilters/FilterSection';
import FilterTab from '../catalogFilters/FilterTab';
import FilterCheckItem from '../catalogFilters/FilterCheckItem';
import FilterItems from '../catalogFilters/FilterCheckItems';

import QuestionMarkPopup from '../popups/QuestionMark';
import * as DiamondAccentContent from '../popups/content/DiamondAccent';
import * as DiamondPaveContent from '../popups/content/DiamondPave';

import css from '@styles/bandFilters';

type TProps = {
  isOpen: boolean,
  onToggle: () => void,
  onFilterCheckToggle: (Category: string, Value: string) => void,
  selectedItems: Array<string>
};

function itemIsSelected (selectedItems, item) {
  return selectedItems.indexOf(item) >= 0;
}

export default function StyleFilters ({
  onFilterCheckToggle,
  selectedItems,
  isOpen,
  onToggle
}: TProps) {
  const handleStyleCheckToggle = useCallback(
    (e) => {
      onFilterCheckToggle('style', e.currentTarget.value);
    },
    [onFilterCheckToggle]
  );

  const handleGenderCheckToggle = useCallback(
    (e) => {
      onFilterCheckToggle('gender', e.currentTarget.value);
    },
    [onFilterCheckToggle]
  );

  return (
    <FilterSection
      className={css.style}
      enableClickOutside={isOpen}
      onClickOutside={onToggle}>
      <FilterTab
        name="Style"
        className={classnames(css.styleTab)}
        showingContent={isOpen}
        activeFilterCount={selectedItems.length}
        onClick={onToggle}
        key="style-tab"
      />
      <FilterItems
        className={css.styleContent}
        show={isOpen}
        key="style-content">
        <FilterCheckItem
          label="Men's"
          inputValue="Mens"
          htmlId="gender-mens"
          selected={itemIsSelected(selectedItems, 'Mens')}
          onChange={handleGenderCheckToggle}
        />
        <FilterCheckItem
          label="Women's"
          inputValue="Womens"
          htmlId="gender-womens"
          selected={itemIsSelected(selectedItems, 'Womens')}
          onChange={handleGenderCheckToggle}
        />
        <FilterCheckItem
          label="Plain Metal"
          inputValue="Plain Metal"
          htmlId="style-plain-metal"
          selected={itemIsSelected(selectedItems, 'Plain Metal')}
          onChange={handleStyleCheckToggle}
        />

        {/*
         * This "Diamond Accent" is intentionally not the same inputValue as
         * the one on engagement rings catalog, don't change!
         * */}
        <FilterCheckItem
          label="Diamond Accent"
          inputValue="Diamond"
          htmlId="style-diamond"
          popup={({ className }) => (
            <QuestionMarkPopup
              initialContent={DiamondAccentContent}
              className={className}
              doNotScrollToPopup
            />
          )}
          selected={itemIsSelected(selectedItems, 'Diamond')}
          onChange={handleStyleCheckToggle}
        />
        <FilterCheckItem
          label="Diamond Pave"
          inputValue="Pave"
          htmlId="style-pave"
          popup={({ className }) => (
            <QuestionMarkPopup
              initialContent={DiamondPaveContent}
              className={className}
              doNotScrollToPopup
            />
          )}
          selected={itemIsSelected(selectedItems, 'Pave')}
          onChange={handleStyleCheckToggle}
        />
      </FilterItems>
    </FilterSection>
  );
}
